import * as moment from 'moment';

export class DraftPick {
    draft_pick_id: string;
    first_name: string;
    last_name: string;
    uid: string;
    startTstamp?: number;
    endTStamp?: number;
    drafted_game_id_fk: string;
    thumb_img: string;
    round_number: string;
    constructor(draftPickJSON) {
        this.draft_pick_id = draftPickJSON.draft_pick_id;
        this.uid = draftPickJSON.uid;
        this.drafted_game_id_fk = draftPickJSON.drafted_game_id_fk;
        this.first_name = draftPickJSON.first_name;
        this.last_name = draftPickJSON.last_name;
        this.thumb_img = draftPickJSON.thumb_img;
        this.round_number = draftPickJSON.round_number;
    }
}
export interface TeamObject {
    teamID: string;
    teamName: string;
    teamCity: string;
}
export class GameObject {
    game_id: string;
    vs_team_id: string;
    team_name: string;
    team_city: string;
    game_tstamp: string;
    owned_by_uid_fk: string;
    q_tstamp?: string;
    face_value?: string;
    team_thumb_img: string;
    isQueued?: any;
    event_time: string;
    event_date: string;
    event_date_readable: string;
    description: string;

    constructor(gameJson) {
        this.game_id = gameJson.game_id;
        this.vs_team_id = gameJson.vs_team_id;
        this.team_name = gameJson.team_name;
        this.team_city = gameJson.team_city;
        this.event_date = gameJson.event_date;
        this.event_time = this.setReadableTime(gameJson.event_time);
        this.owned_by_uid_fk = gameJson.owned_by_uid_fk;
        this.team_thumb_img = gameJson.team_thumb_img;
        this.event_date_readable = this.setReadable(this.event_date, this.event_time);
        this.face_value = gameJson.face_value;
        this.description = gameJson.event_description;

        // logic for readable
    }
    setReadable(event_date, event_time) {
        const date = new Date(this.event_date);
        event_date = moment(date).format('dddd, MMMM Do, YYYY');
        // event_time =  moment(event_time, "hh").format('LT');  not using time to break up the lines
        return event_date;
    }
    setReadableTime(time) {
        const event_time = moment(time, 'hh').format('LT');
        return event_time;
    }

}
export class GroupMember {
    thumb_img: string;
    first_name: string;
    last_name: string;
    uid: string;
    joined_tstamp: string;
    did_onboard_ticketmaster: boolean;
    is_leader: any; 

    constructor(JSONData) {
        this.uid = JSONData.uid;
        this.first_name = JSONData.first_name;
        this.last_name = JSONData.last_name;
        this.thumb_img = JSONData.thumb_img;
        this.joined_tstamp = JSONData.joined_tstamp;
        this.did_onboard_ticketmaster = JSONData.did_onboard_ticketmaster;
        if(JSONData.is_leader){
            this.is_leader = JSONData.is_leader;
        }
    }
}

export class SeasonTicket {
    seasonTicketID: string;
    sport: string;
    team: string;
    team_city: string;
    section: string;
    seats: string;
    issuedTstamp: number;
    issuedReadable: string;
    games: Array<GameObject> = [];
    season_ticket_id: Number;
    description: string;
    type: string; 

    // seat data
    row: string;
    seat_num: string;
    last_seat: string;
    tm_order_num_out: string;
    total_price: string;
    tm_event_name?: string;
    team_thumb_img: any;
    display_text: string;

    constructor(seasonTicketJson) {
        this.seasonTicketID = seasonTicketJson.id;
        this.sport = seasonTicketJson.sport;
        this.team = seasonTicketJson.team_name_full;
        this.section = seasonTicketJson.section;
        this.seats = 'TELLCHUCK';
        this.description = seasonTicketJson.description;
        this.team_city = seasonTicketJson.team_city;
        this.issuedTstamp = seasonTicketJson.issued_tstamp;
        this.issuedReadable = seasonTicketJson.issued_readable;
        this.season_ticket_id = seasonTicketJson.season_ticket_id;
        this.type = seasonTicketJson.type; 
        // initialize games in season ticket
        seasonTicketJson.games.forEach(gameJson => {
            const a = new GameObject(gameJson);
            this.games.push(a);
        });
        // seat data
        this.row = seasonTicketJson.row;
        this.seat_num = seasonTicketJson.seat_num;
        this.last_seat = seasonTicketJson.last_seat;
        this.tm_order_num_out = seasonTicketJson.tm_order_num_out;
        this.total_price = seasonTicketJson.subtotal;
        this.tm_event_name = seasonTicketJson.tm_event_name;
        this.team_thumb_img = seasonTicketJson.team_thumb_img;
        this.display_text = seasonTicketJson.display_text;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/draft.ts